import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { RobustnessScore, RobustnessScoreApiPayload } from '../models/robustness';
import { ITeamRobustnessScoreAnalysis } from '../_interfaces/teamRobustnessScoreAnalysis';

@Injectable({
  providedIn: 'root',
})
export class RobustnessService {
  baseUrl: string = environment.apiUrl;

  constructor(private HttpClient: HttpClient) {}

  getTeamRobustnessScore(teamId: number): Observable<RobustnessScoreApiPayload> {
    return this.HttpClient.get<RobustnessScoreApiPayload>(
      `${this.baseUrl}/robustness/teams/${teamId}`
    );
  }


  calculateTeamRobustnessScore(teamId: number): Observable<RobustnessScore> {
    return this.HttpClient.post<RobustnessScore>(
      `${this.baseUrl}/robustness/teams/${teamId}/calculate`,
      {}
    );
  }

  getTeamRobustnessScoreAiAnalysis(teamId: number): Observable<ITeamRobustnessScoreAnalysis> {
    return this.HttpClient.get<ITeamRobustnessScoreAnalysis>(
      `${this.baseUrl}/robustness/teams/${teamId}/analyze`
    );
  }
}